const framePage = {
	allowSubmit: true,
	facebookAllowSubmit: true
};

export default framePage;
